import { render } from "./cpt-num.vue?vue&type=template&id=63679f78"
import script from "./cpt-num.vue?vue&type=script&lang=js"
export * from "./cpt-num.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__